import { render, staticRenderFns } from "./NotificationsSettingsList.vue?vue&type=template&id=7d92900f&scoped=true"
import script from "./NotificationsSettingsList.vue?vue&type=script&lang=js"
export * from "./NotificationsSettingsList.vue?vue&type=script&lang=js"
import style0 from "./NotificationsSettingsList.vue?vue&type=style&index=0&id=7d92900f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d92900f",
  null
  
)

export default component.exports